(function () {
  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function getSlider(key) {
    return document.getElementById('MovitaSlider-' + key);
  }

  function getSlides(slider) {
    if (!slider) return [];
    return Array.prototype.slice.call(slider.children).filter(function (el) {
      return el.classList && el.classList.contains('movita-slide');
    });
  }

  function getKey(slider) {
    return (slider && slider.id ? slider.id : '').replace(/^MovitaSlider-/, '');
  }

  function getActiveIndex(slider, slides) {
    if (!slider || !slides.length) return 0;
    var firstLeft = slides[0].offsetLeft;
    var current = slider.scrollLeft;
    var best = 0;
    var smallest = Infinity;
    slides.forEach(function (slide, index) {
      var distance = Math.abs((slide.offsetLeft - firstLeft) - current);
      if (distance < smallest) {
        smallest = distance;
        best = index;
      }
    });
    return best;
  }

  function scrollToSlide(slider, slides, index, behavior) {
    if (!slider || !slides.length) return;
    var safe = Math.max(0, Math.min(slides.length - 1, index));
    var left = slides[safe].offsetLeft - slides[0].offsetLeft;
    try {
      slider.scrollTo({ left: left, behavior: behavior || 'smooth' });
    } catch (e) {
      slider.scrollLeft = left;
    }
    updateDots(slider);
  }

  function updateHeroGallery(slider, slides, active) {
    if (!slider) return;
    var gallery = slider.closest('[data-movita-hero-gallery]');
    if (!gallery) return;
    var thumbs = qsa(gallery, '[data-movita-gallery-thumb]');
    thumbs.forEach(function (thumb, index) {
      var selected = index === active;
      thumb.classList.toggle('is-active', selected);
      thumb.setAttribute('aria-current', selected ? 'true' : 'false');
    });
    (slides || getSlides(slider)).forEach(function (slide, index) {
      slide.setAttribute('aria-hidden', index === active ? 'false' : 'true');
    });
    var status = gallery.querySelector('[data-movita-gallery-status]');
    if (status) {
      var currentSlide = (slides || getSlides(slider))[active];
      var label = currentSlide ? currentSlide.getAttribute('data-gallery-label') : '';
      status.textContent = 'Image ' + (active + 1) + ' of ' + (slides || getSlides(slider)).length + (label ? ': ' + label : '');
    }
  }

  function updateDots(slider) {
    if (!slider) return;
    var dots = document.querySelector('[data-slider-dots-for="' + slider.id + '"]');
    var slides = getSlides(slider);
    var active = getActiveIndex(slider, slides);
    if (dots) {
      qsa(dots, 'button').forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === active);
      });
    }
    slider.setAttribute('data-active-slide', String(active + 1));
    updateHeroGallery(slider, slides, active);
  }

  function buildDots(slider) {
    if (!slider) return;
    var dots = document.querySelector('[data-slider-dots-for="' + slider.id + '"]');
    if (!dots) return;
    var slides = getSlides(slider);
    dots.innerHTML = '';
    slides.forEach(function (_, index) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'movita-slider-dot' + (index === 0 ? ' is-active' : '');
      btn.setAttribute('aria-label', 'Go to slide ' + (index + 1));
      btn.setAttribute('data-slider-dot-index', String(index));
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        scrollToSlide(slider, getSlides(slider), index, 'smooth');
      });
      dots.appendChild(btn);
    });
  }

  function initSliders(scope) {
    qsa(scope || document, '[data-movita-slider]').forEach(function (slider) {
      if (slider.dataset.movitaReady === 'true') {
        buildDots(slider);
        updateDots(slider);
        return;
      }
      slider.dataset.movitaReady = 'true';
      buildDots(slider);
      updateDots(slider);
      var ticking = false;
      slider.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateDots(slider);
          ticking = false;
        });
      }, { passive: true });
    });
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-slider-prev]');
    var next = event.target.closest('[data-slider-next]');
    if (!prev && !next) return;
    event.preventDefault();
    event.stopPropagation();
    var key = prev ? prev.getAttribute('data-slider-prev') : next.getAttribute('data-slider-next');
    var slider = getSlider(key);
    var slides = getSlides(slider);
    if (!slider || !slides.length) return;
    var active = getActiveIndex(slider, slides);
    scrollToSlide(slider, slides, active + (next ? 1 : -1), 'smooth');
  });

  function initHeroGallery(scope) {
    qsa(scope || document, '[data-movita-hero-gallery]').forEach(function (gallery) {
      if (gallery.dataset.movitaHeroGalleryReady === 'true') return;
      gallery.dataset.movitaHeroGalleryReady = 'true';
      var slider = gallery.querySelector('[data-movita-slider]');
      if (!slider) return;
      var thumbs = qsa(gallery, '[data-movita-gallery-thumb]');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          var index = parseInt(thumb.getAttribute('data-slide-index'), 10);
          if (isNaN(index)) return;
          scrollToSlide(slider, getSlides(slider), index, 'smooth');
        });
        thumb.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
          event.preventDefault();
          var current = thumbs.indexOf(thumb);
          var target = current;
          if (event.key === 'ArrowLeft') target = Math.max(0, current - 1);
          if (event.key === 'ArrowRight') target = Math.min(thumbs.length - 1, current + 1);
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = thumbs.length - 1;
          thumbs[target].focus();
          scrollToSlide(slider, getSlides(slider), target, 'smooth');
        });
      });

      slider.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && event.key !== 'Home' && event.key !== 'End') return;
        event.preventDefault();
        var slides = getSlides(slider);
        var active = getActiveIndex(slider, slides);
        var target = active;
        if (event.key === 'ArrowLeft') target = Math.max(0, active - 1);
        if (event.key === 'ArrowRight') target = Math.min(slides.length - 1, active + 1);
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = slides.length - 1;
        scrollToSlide(slider, slides, target, 'smooth');
      });

      updateDots(slider);
    });
  }

  function initVariantSelection(scope) {
    qsa(scope || document, '.movita-v44-form select[name="id"]').forEach(function (select) {
      if (select.dataset.movitaVariantReady === 'true') return;
      select.dataset.movitaVariantReady = 'true';
      var root = select.closest('.movita-theme') || document;

      function syncSelectedVariant() {
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var variantId = option.value;
        var price = option.getAttribute('data-variant-price') || '';
        var available = option.getAttribute('data-variant-available') !== 'false' && !option.disabled;

        qsa(root, '.movita-purchase-form input[type="hidden"][name="id"]').forEach(function (input) {
          input.value = variantId;
        });
        qsa(root, '.movita-v44-price, .movita-v52-price, .movita-v55-price').forEach(function (priceNode) {
          if (price) priceNode.textContent = price;
        });
        qsa(root, '.movita-v44-primary[data-movita-single-submit], .movita-v52-cta[data-movita-single-submit], .movita-v55-primary[data-movita-single-submit]').forEach(function (button) {
          button.disabled = !available;
          button.textContent = available ? 'GET THE MOVITA KIT — ' + price : 'Sold Out';
          if (available) delete button.dataset.movitaInitialDisabled;
          else button.dataset.movitaInitialDisabled = 'true';
        });
        var stickyCopy = root.querySelector('.movita-v43-sticky-copy span');
        if (stickyCopy && price) stickyCopy.textContent = price + ' · FREE UK Delivery';
        qsa(root, '[data-movita-sticky-submit]').forEach(function (button) {
          button.disabled = !available;
          if (available) delete button.dataset.movitaInitialDisabled;
          else button.dataset.movitaInitialDisabled = 'true';
        });
      }

      select.addEventListener('change', syncSelectedVariant);
      syncSelectedVariant();
    });
  }

  function initReviewPagination(scope) {
    qsa(scope || document, '[data-review-pages]').forEach(function (wrap) {
      if (wrap.dataset.reviewReady === 'true') return;
      wrap.dataset.reviewReady = 'true';
      var buttons = qsa(wrap, '[data-review-page-button]');
      function setPage(page) {
        wrap.setAttribute('data-active-page', page);
        qsa(wrap, '[data-review-page-button]').forEach(function (button) {
          button.classList.toggle('is-active', button.getAttribute('data-review-page-button') === page);
        });
      }
      buttons.forEach(function (button) {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          setPage(button.getAttribute('data-review-page-button'));
        });
      });
      setPage(wrap.getAttribute('data-active-page') || '1');
    });
  }

  function initStickyBuyVisibility() {
    var sticky = document.querySelector('[data-movita-sticky-buy]');
    var heroPurchase = document.querySelector('[data-movita-hero-purchase]');
    var finalPurchase = document.querySelector('[data-movita-final-purchase]');
    if (!sticky || !heroPurchase || sticky.dataset.stickyReady === 'true') return;
    sticky.dataset.stickyReady = 'true';

    var ticking = false;
    function update() {
      var heroRect = heroPurchase.getBoundingClientRect();
      var finalRect = finalPurchase ? finalPurchase.getBoundingClientRect() : null;
      var heroPassed = heroRect.bottom < 0;
      var beforeFinalPurchase = !finalRect || finalRect.top > (window.innerHeight * 0.82);
      var videoControlsNearBar = qsa(document, 'video[controls], [data-movita-friction-media].is-playing, [data-movita-workout-media].is-playing, [data-movita-r21-media].is-playing').some(function (media) {
        var rect = media.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > (window.innerHeight - 82);
      });
      var shouldShow = heroPassed && beforeFinalPurchase && !videoControlsNearBar;
      sticky.classList.toggle('is-hidden', !shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('play', requestUpdate, true);
    document.addEventListener('pause', requestUpdate, true);
    document.addEventListener('ended', requestUpdate, true);
  }

  function initStickyPurchase(scope) {
    qsa(scope || document, '[data-movita-sticky-submit]').forEach(function (button) {
      if (button.dataset.movitaStickyReady === 'true') return;
      button.dataset.movitaStickyReady = 'true';
      if (button.disabled) button.dataset.movitaInitialDisabled = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (button.disabled) return;
        var form = document.getElementById('MovitaProductFormHero');
        if (!form || form.dataset.movitaSubmitting === 'true') return;
        var submit = form.querySelector('[data-movita-single-submit]');
        if (!submit || submit.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (form.requestSubmit) form.requestSubmit(submit);
        else submit.click();
      });
    });
  }

  var policyCheckoutSelector = '[data-policy-checkout-button], button[name="checkout"], input[name="checkout"], a[href*="/checkout"], button[formaction*="/checkout"], input[formaction*="/checkout"], .shopify-payment-button__button, [data-testid="Checkout-button"]';

  function isCheckoutControl(element) {
    return !!(element && element.matches && element.matches(policyCheckoutSelector));
  }

  function getPolicyScope(control) {
    if (!control || !control.closest) return null;
    return control.closest('form, cart-drawer, .cart-drawer, #CartDrawer, [data-cart-drawer], [id*="CartDrawer"], [class*="cart-drawer"]') || control.parentElement;
  }

  function getPolicyAcceptance(control) {
    var scope = getPolicyScope(control);
    if (!scope || !scope.querySelector) return null;
    return scope.querySelector('[data-policy-acceptance]');
  }

  function createPolicyAcceptance(control) {
    var existing = getPolicyAcceptance(control);
    if (existing) return existing;
    var template = document.getElementById('MovitaPolicyAcceptanceTemplate');
    if (!template || !template.content || !control || !control.parentNode) return null;
    var fragment = template.content.cloneNode(true);
    var acceptance = fragment.querySelector('[data-policy-acceptance]');
    control.parentNode.insertBefore(fragment, control);
    return acceptance;
  }

  function showPolicyValidation(acceptance) {
    if (!acceptance) return;
    var validation = acceptance.querySelector('[data-policy-validation]');
    var checkbox = acceptance.querySelector('[data-policy-checkbox]');
    if (validation) validation.hidden = false;
    acceptance.classList.add('has-error');
    if (checkbox) {
      checkbox.setAttribute('aria-invalid', 'true');
      try { checkbox.focus({ preventScroll: true }); } catch (e) { checkbox.focus(); }
    }
    try { acceptance.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }

  function clearPolicyValidation(acceptance) {
    if (!acceptance) return;
    var validation = acceptance.querySelector('[data-policy-validation]');
    var checkbox = acceptance.querySelector('[data-policy-checkbox]');
    if (validation) validation.hidden = true;
    acceptance.classList.remove('has-error');
    if (checkbox) checkbox.removeAttribute('aria-invalid');
  }

  function policyAccepted(control) {
    var acceptance = getPolicyAcceptance(control) || createPolicyAcceptance(control);
    if (!acceptance) return false;
    var checkbox = acceptance.querySelector('[data-policy-checkbox]');
    if (checkbox && checkbox.checked) {
      clearPolicyValidation(acceptance);
      return true;
    }
    showPolicyValidation(acceptance);
    return false;
  }

  function scanCheckoutControls(scope) {
    qsa(scope || document, policyCheckoutSelector).forEach(function (control) {
      createPolicyAcceptance(control);
    });
  }

  function initPolicyAcceptance(scope) {
    scanCheckoutControls(scope || document);
    if (document.documentElement.dataset.movitaPolicyReady === 'true') return;
    document.documentElement.dataset.movitaPolicyReady = 'true';

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-policy-checkbox]')) return;
      var acceptance = event.target.closest('[data-policy-acceptance]');
      if (event.target.checked) clearPolicyValidation(acceptance);
    });

    document.addEventListener('click', function (event) {
      var control = event.target.closest(policyCheckoutSelector);
      if (!control) return;
      if (policyAccepted(control)) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form')) return;
      var submitter = event.submitter || null;
      var action = (form.getAttribute('action') || '').toLowerCase();
      var checkoutIntent = (submitter && isCheckoutControl(submitter)) || action.indexOf('/checkout') !== -1;
      if (!checkoutIntent) return;
      var control = submitter || form.querySelector(policyCheckoutSelector) || form;
      if (policyAccepted(control)) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }, true);

    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            if (!node || node.nodeType !== 1) return;
            if (node.matches && node.matches(policyCheckoutSelector)) createPolicyAcceptance(node);
            scanCheckoutControls(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function policyCards() {
    return qsa(document, 'details[data-movita-policy-card]');
  }

  function closeOtherPolicyCards(activeCard) {
    policyCards().forEach(function (card) {
      if (card !== activeCard) card.open = false;
    });
  }

  function scrollPolicyCard(card) {
    if (!card) return;
    var header = document.querySelector('[data-movita-section0-header]');
    var headerHeight = header ? header.getBoundingClientRect().height : 64;
    var top = Math.max(0, window.pageYOffset + card.getBoundingClientRect().top - headerHeight - 16);
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      window.scrollTo({ top: top, behavior: reducedMotion ? 'auto' : 'smooth' });
    } catch (e) {
      window.scrollTo(0, top);
    }
  }

  function openPolicyHash() {
    var hash = window.location.hash;
    if (!hash) return;
    var target;
    try { target = document.querySelector(hash); } catch (e) { return; }
    if (!target || !target.matches || !target.matches('details[data-movita-policy-card]')) return;
    closeOtherPolicyCards(target);
    target.open = true;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { scrollPolicyCard(target); });
    });
  }

  function initPolicyAccordions(scope) {
    qsa(scope || document, 'details[data-movita-policy-card]').forEach(function (card) {
      if (card.dataset.movitaPolicyAccordionReady === 'true') return;
      card.dataset.movitaPolicyAccordionReady = 'true';
      card.addEventListener('toggle', function () {
        if (card.open) closeOtherPolicyCards(card);
      });
    });

    if (document.documentElement.dataset.movitaPolicyHashReady === 'true') return;
    document.documentElement.dataset.movitaPolicyHashReady = 'true';
    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      if (!link) return;
      var hash = link.getAttribute('href');
      var target;
      try { target = hash ? document.querySelector(hash) : null; } catch (e) { return; }
      if (!target || !target.matches || !target.matches('details[data-movita-policy-card]')) return;
      if (window.location.hash === hash) {
        event.preventDefault();
        openPolicyHash();
      }
    });
  }

  function initSingleSubmitPurchaseForms(scope) {
    qsa(scope || document, '.movita-purchase-form').forEach(function (form) {
      if (form.dataset.movitaPurchaseReady === 'true') return;
      form.dataset.movitaPurchaseReady = 'true';
      var initialButton = form.querySelector('[data-movita-single-submit]');
      if (initialButton && initialButton.disabled) initialButton.dataset.movitaInitialDisabled = 'true';
      form.addEventListener('submit', function (event) {
        if (form.dataset.movitaSubmitting === 'true') {
          event.preventDefault();
          return;
        }
        form.dataset.movitaSubmitting = 'true';
        var button = form.querySelector('[data-movita-single-submit]');
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        }
      });
    });
  }

  function resetPurchaseForms() {
    qsa(document, '[data-movita-sticky-submit]').forEach(function (button) { if (button.dataset.movitaInitialDisabled !== 'true') button.disabled = false; button.removeAttribute('aria-busy'); });
    qsa(document, '.movita-purchase-form').forEach(function (form) {
      form.dataset.movitaSubmitting = 'false';
      var button = form.querySelector('[data-movita-single-submit]');
      if (button && button.dataset.movitaInitialDisabled !== 'true') {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  }

  function initSection0Header(scope) {
    qsa(scope || document, '[data-movita-section0-header]').forEach(function (header) {
      if (header.dataset.movitaSection0Ready === 'true') return;
      header.dataset.movitaSection0Ready = 'true';

      var root = header.closest('.movita-theme') || document;
      var toggle = root.querySelector('[data-movita-mobile-menu-toggle]');
      var menu = toggle ? document.getElementById(toggle.getAttribute('aria-controls')) : null;
      var previousFocus = null;
      var closeTimer = null;
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      function updateStickyState() {
        var rect = header.getBoundingClientRect();
        header.classList.toggle('is-scrolled', window.scrollY > 0 && rect.top <= 0.5);
      }

      var stickyTicking = false;
      function requestStickyUpdate() {
        if (stickyTicking) return;
        stickyTicking = true;
        window.requestAnimationFrame(function () {
          updateStickyState();
          stickyTicking = false;
        });
      }

      updateStickyState();
      window.addEventListener('scroll', requestStickyUpdate, { passive: true });
      window.addEventListener('resize', requestStickyUpdate);

      if (!toggle || !menu) return;

      function focusables() {
        return qsa(menu, focusableSelector).filter(function (element) {
          return !element.hasAttribute('hidden') && element.getClientRects().length > 0;
        });
      }

      function openMenu() {
        if (!menu.hidden && menu.classList.contains('is-open')) return;
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
        previousFocus = document.activeElement;
        menu.hidden = false;
        menu.setAttribute('aria-hidden', 'false');
        toggle.setAttribute('aria-expanded', 'true');
        document.body.classList.add('movita-section0-menu-open');
        window.requestAnimationFrame(function () {
          menu.classList.add('is-open');
          var closeButton = menu.querySelector('.movita-v43-menu-close');
          if (closeButton) closeButton.focus();
        });
      }

      function finishClose(restoreFocus) {
        menu.hidden = true;
        if (restoreFocus && toggle && document.contains(toggle)) toggle.focus();
      }

      function closeMenu(restoreFocus) {
        if (menu.hidden) return;
        menu.classList.remove('is-open');
        menu.setAttribute('aria-hidden', 'true');
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('movita-section0-menu-open');
        var shouldRestore = restoreFocus !== false;
        if (reducedMotion) {
          finishClose(shouldRestore);
        } else {
          closeTimer = window.setTimeout(function () {
            finishClose(shouldRestore);
            closeTimer = null;
          }, 210);
        }
      }

      toggle.addEventListener('click', function () { openMenu(); });

      qsa(menu, '[data-movita-mobile-menu-close]').forEach(function (control) {
        control.addEventListener('click', function () { closeMenu(true); });
      });

      qsa(menu, '[data-movita-mobile-menu-link]').forEach(function (link) {
        link.addEventListener('click', function () { closeMenu(false); });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !menu.hidden) {
          event.preventDefault();
          closeMenu(true);
        }
      });

      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeMenu(true);
          return;
        }
        if (event.key !== 'Tab') return;
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth >= 1024 && !menu.hidden) closeMenu(false);
      });
    });
  }

  function initFrictionMedia(scope) {
    qsa(scope || document, '[data-movita-friction-media]').forEach(function (wrap) {
      if (wrap.dataset.movitaFrictionReady === 'true') return;
      wrap.dataset.movitaFrictionReady = 'true';

      var video = wrap.querySelector('[data-movita-friction-video]');
      var toggle = wrap.querySelector('[data-movita-friction-toggle]');
      if (!video || !toggle) return;

      var icon = toggle.querySelector('[data-movita-friction-toggle-icon]');
      var label = toggle.querySelector('[data-movita-friction-toggle-label]');
      var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var userPaused = false;
      var observer = null;

      function reducedMotion() {
        return !!(motionQuery && motionQuery.matches);
      }

      function setPoster() {
        var mobile = window.innerWidth <= 767;
        var poster = mobile ? video.getAttribute('data-poster-mobile') : video.getAttribute('data-poster-desktop');
        if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
      }

      function updateControl() {
        var playing = !video.paused && !video.ended;
        wrap.classList.toggle('is-playing', playing);
        if (icon) icon.textContent = playing ? 'Ⅱ' : '▶';
        if (label) label.textContent = playing ? 'Pause' : 'Play';
        toggle.setAttribute('aria-label', (playing ? 'Pause' : 'Play') + ' gym-friction product demonstration');
      }

      function safePlay() {
        if (reducedMotion() || userPaused) return;
        var attempt = video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(updateControl).catch(updateControl);
        } else {
          updateControl();
        }
      }

      function pauseForViewport() {
        if (!video.paused) video.pause();
        updateControl();
      }

      setPoster();
      updateControl();

      toggle.addEventListener('click', function () {
        if (video.paused || video.ended) {
          userPaused = false;
          var attempt = video.play();
          if (attempt && typeof attempt.then === 'function') {
            attempt.then(updateControl).catch(updateControl);
          } else {
            updateControl();
          }
        } else {
          userPaused = true;
          video.pause();
          updateControl();
        }
      });

      video.addEventListener('play', updateControl);
      video.addEventListener('pause', updateControl);
      video.addEventListener('ended', updateControl);

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== wrap) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) safePlay();
            else pauseForViewport();
          });
        }, { threshold: [0, 0.55, 1] });
        observer.observe(wrap);
      }

      window.addEventListener('resize', setPoster);

      if (motionQuery) {
        var onMotionChange = function () {
          if (reducedMotion()) {
            video.pause();
            updateControl();
          }
        };
        if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
        else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
      }
    });
  }

  function initWorkoutProofMedia(scope) {
    qsa(scope || document, '[data-movita-workout-media]').forEach(function (wrap) {
      if (wrap.dataset.movitaWorkoutReady === 'true') return;
      wrap.dataset.movitaWorkoutReady = 'true';

      var video = wrap.querySelector('[data-movita-workout-video]');
      var toggle = wrap.querySelector('[data-movita-workout-toggle]');
      if (!video || !toggle) return;

      var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 767px)') : null;
      var userPaused = false;
      var sourceLoaded = false;
      var loadObserver = null;
      var playObserver = null;
      var onMotionChange = null;
      var onViewportChange = null;

      function reducedMotion() {
        return !!(motionQuery && motionQuery.matches);
      }

      function isMobile() {
        return mobileQuery ? mobileQuery.matches : window.innerWidth <= 767;
      }

      function desiredSource() {
        return isMobile() ? video.getAttribute('data-video-mobile') : video.getAttribute('data-video-desktop');
      }

      function desiredPoster() {
        return isMobile() ? video.getAttribute('data-poster-mobile') : video.getAttribute('data-poster-desktop');
      }

      function setPoster() {
        var poster = desiredPoster();
        if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
      }

      function updateControl() {
        var playing = !video.paused && !video.ended;
        wrap.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-label', playing ? 'Pause workout video' : 'Play workout video');
      }

      function ensureSource() {
        var src = desiredSource();
        if (!src) return false;
        if (video.dataset.movitaWorkoutSrc === src) {
          sourceLoaded = true;
          return true;
        }
        var wasPlaying = !video.paused && !video.ended;
        video.pause();
        video.src = src;
        video.dataset.movitaWorkoutSrc = src;
        sourceLoaded = true;
        video.load();
        updateControl();
        if (wasPlaying && !userPaused && !reducedMotion()) {
          var retry = video.play();
          if (retry && typeof retry.catch === 'function') retry.catch(function () {});
        }
        return true;
      }

      function playVideo(manual) {
        if (!manual && reducedMotion()) return;
        if (!ensureSource()) return;
        var attempt = video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(updateControl).catch(function () {
            updateControl();
            if (!manual || video.readyState >= 2) return;
            video.addEventListener('canplay', function retryManualPlayback() {
              var retry = video.play();
              if (retry && typeof retry.then === 'function') retry.then(updateControl).catch(updateControl);
              else updateControl();
            }, { once: true });
          });
        } else {
          updateControl();
        }
      }

      function pauseVideo() {
        if (!video.paused) video.pause();
        updateControl();
      }

      function togglePlayback() {
        if (video.paused || video.ended) {
          userPaused = false;
          playVideo(true);
        } else {
          userPaused = true;
          pauseVideo();
        }
      }

      setPoster();
      updateControl();
      toggle.addEventListener('click', togglePlayback);
      video.addEventListener('click', togglePlayback);
      video.addEventListener('play', updateControl);
      video.addEventListener('pause', updateControl);
      video.addEventListener('ended', updateControl);

      if ('IntersectionObserver' in window) {
        loadObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== wrap || !entry.isIntersecting) return;
            ensureSource();
            if (loadObserver) {
              loadObserver.disconnect();
              loadObserver = null;
            }
          });
        }, { rootMargin: '320px 0px', threshold: 0 });
        loadObserver.observe(wrap);

        playObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== wrap) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              if (!userPaused) playVideo(false);
            } else {
              pauseVideo();
            }
          });
        }, { threshold: [0, 0.55, 1] });
        playObserver.observe(wrap);
      }

      onViewportChange = function () {
        setPoster();
        if (sourceLoaded) ensureSource();
      };

      if (mobileQuery) {
        if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onViewportChange);
        else if (mobileQuery.addListener) mobileQuery.addListener(onViewportChange);
      }

      if (motionQuery) {
        onMotionChange = function () {
          if (reducedMotion()) pauseVideo();
        };
        if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
        else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
      }

      wrap._movitaWorkoutCleanup = function () {
        if (loadObserver) loadObserver.disconnect();
        if (playObserver) playObserver.disconnect();
        toggle.removeEventListener('click', togglePlayback);
        video.removeEventListener('click', togglePlayback);
        video.removeEventListener('play', updateControl);
        video.removeEventListener('pause', updateControl);
        video.removeEventListener('ended', updateControl);
        if (mobileQuery && onViewportChange) {
          if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', onViewportChange);
          else if (mobileQuery.removeListener) mobileQuery.removeListener(onViewportChange);
        }
        if (motionQuery && onMotionChange) {
          if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', onMotionChange);
          else if (motionQuery.removeListener) motionQuery.removeListener(onMotionChange);
        }
      };
    });
  }

  function initResistance21Media(scope) {
    qsa(scope || document, '[data-movita-r21-media]').forEach(function (wrap) {
      if (wrap.dataset.movitaR21Ready === 'true') return;
      wrap.dataset.movitaR21Ready = 'true';

      var video = wrap.querySelector('[data-movita-r21-video]');
      var control = wrap.querySelector('[data-movita-r21-replay]');
      if (!video || !control) return;

      var controlLabel = control.querySelector('[data-movita-r21-replay-label]');
      var motionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      var loadObserver = null;
      var playObserver = null;
      var sourceLoaded = false;
      var hasStarted = false;
      var hasEnded = false;
      var userPaused = false;
      var onMotionChange = null;

      function reducedMotion() {
        return !!(motionQuery && motionQuery.matches);
      }

      function preferredSource() {
        var webm = video.getAttribute('data-video-webm') || '';
        var mp4 = video.getAttribute('data-video-mp4') || '';
        if (webm && video.canPlayType && video.canPlayType('video/webm')) return webm;
        return mp4 || webm;
      }

      function ensureSource() {
        var source = preferredSource();
        if (!source) return false;
        if (video.dataset.movitaR21Src === source) {
          sourceLoaded = true;
          return true;
        }
        video.src = source;
        video.dataset.movitaR21Src = source;
        sourceLoaded = true;
        video.load();
        return true;
      }

      function updateControl() {
        var playing = !video.paused && !video.ended;
        var text = hasEnded ? 'Replay walkthrough' : (playing ? 'Pause walkthrough' : 'Play walkthrough');
        if (controlLabel) controlLabel.textContent = text;
        control.setAttribute('aria-label', text === 'Replay walkthrough' ? 'Replay Resistance21 walkthrough' : text.replace('walkthrough', 'Resistance21 walkthrough'));
        wrap.classList.toggle('is-playing', playing);
      }

      function playVideo(manual) {
        if (!manual && reducedMotion()) return;
        if (!ensureSource()) return;
        if (hasEnded) {
          try { video.currentTime = 0; } catch (e) {}
          hasEnded = false;
        }
        var attempt = video.play();
        hasStarted = true;
        userPaused = false;
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(updateControl).catch(updateControl);
        } else {
          updateControl();
        }
      }

      function pauseVideo(fromUser) {
        if (!video.paused) video.pause();
        if (fromUser) userPaused = true;
        updateControl();
      }

      function togglePlayback() {
        if (video.paused || video.ended) playVideo(true);
        else pauseVideo(true);
      }

      control.addEventListener('click', togglePlayback);
      video.addEventListener('play', updateControl);
      video.addEventListener('pause', updateControl);
      video.addEventListener('ended', function () {
        hasEnded = true;
        userPaused = false;
        updateControl();
      });
      updateControl();

      if ('IntersectionObserver' in window) {
        loadObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== wrap || !entry.isIntersecting) return;
            ensureSource();
            if (loadObserver) {
              loadObserver.disconnect();
              loadObserver = null;
            }
          });
        }, { rootMargin: '320px 0px', threshold: 0 });
        loadObserver.observe(wrap);

        playObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== wrap) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
              if (hasEnded || userPaused || reducedMotion()) return;
              if (!hasStarted || video.paused) playVideo(false);
            } else if (hasStarted && !hasEnded) {
              pauseVideo(false);
            }
          });
        }, { threshold: [0, 0.55, 1] });
        playObserver.observe(wrap);
      }

      if (motionQuery) {
        onMotionChange = function () {
          if (reducedMotion()) pauseVideo(false);
        };
        if (motionQuery.addEventListener) motionQuery.addEventListener('change', onMotionChange);
        else if (motionQuery.addListener) motionQuery.addListener(onMotionChange);
      }

      wrap._movitaR21Cleanup = function () {
        if (loadObserver) loadObserver.disconnect();
        if (playObserver) playObserver.disconnect();
        control.removeEventListener('click', togglePlayback);
        if (motionQuery && onMotionChange) {
          if (motionQuery.removeEventListener) motionQuery.removeEventListener('change', onMotionChange);
          else if (motionQuery.removeListener) motionQuery.removeListener(onMotionChange);
        }
      };
    });
  }

  function initAll(scope) {
    initSection0Header(scope || document);
    initVariantSelection(scope || document);
    initSingleSubmitPurchaseForms(scope || document);
    initStickyPurchase(scope || document);
    initSliders(scope || document);
    initHeroGallery(scope || document);
    initFrictionMedia(scope || document);
    initWorkoutProofMedia(scope || document);
    initResistance21Media(scope || document);
    initReviewPagination(scope || document);
    initStickyBuyVisibility();
    initPolicyAcceptance(scope || document);
    initPolicyAccordions(scope || document);
    openPolicyHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  window.addEventListener('pageshow', resetPurchaseForms);
  window.addEventListener('hashchange', openPolicyHash);
  window.addEventListener('resize', function () {
    qsa(document, '[data-movita-slider]').forEach(function (slider) { updateDots(slider); });
  });
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    qsa(event.target, '[data-movita-workout-media]').forEach(function (wrap) {
      if (typeof wrap._movitaWorkoutCleanup === 'function') wrap._movitaWorkoutCleanup();
    });
    qsa(event.target, '[data-movita-r21-media]').forEach(function (wrap) {
      if (typeof wrap._movitaR21Cleanup === 'function') wrap._movitaR21Cleanup();
    });
  });
})();
